import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {

  @Input()
  label='';

  @Input()
  activeArrow: boolean = true;

  @Input()
  iconClass: string = '';

  @Input()
  href: string = '';

  @Input()
  modalFooter: boolean = false;

  @Input()
  buttonType: string = 'blue';

  @Input()
  disabled: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
